<template>
  <div>
    <div ref="chart" style="width:100px;height:100px"></div>
  </div>

</template>

<script>
  import 'echarts-liquidfill/src/liquidFill.js'; //在这里引入
  export default {
    data() {
      return{

      }
    },
    mounted() {
      this.getEchartData()
    },
    methods: {
      getEchartData() {
        const chart = this.$refs.chart
        if (chart) {
          const myChart = this.$echarts.init(chart)
          const option = {
            title: {
              text: 540,
              textStyle: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
              },
              x: "center",
              y: "center",
            },
            series: [{
              type: "liquidFill",
              radius: '80px',
              data: [.6],
              backgroundStyle: {
                color: 'rgba(0, 0, 0, 0)'
              },
              outline: {
                  show: true,
                  borderDistance: 8,
                  itemStyle: {
                      color: 'none',
                      borderColor: '#1F4D80',
                      borderWidth: 2,
                      shadowBlur: 20,
                      shadowColor: 'rgba(0, 0, 0, 0.25)'
                  }
              },
              label: {
                normal: {
                  formatter: '',
                }
              },
            }]
          };
          myChart.setOption(option)
          window.addEventListener("resize", function() {
            myChart.resize()
          })
        }
        this.$on('hook:destroyed',()=>{
          window.removeEventListener("resize", function() {
            myChart.resize();
          });
        })
      },
    },
  }
</script>
